var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForeheadDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 110,
    viewBox: "0 0 106 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 105.554,
    height: 108.924,
    rx: 32.5647,
    fill: "#FFBEA9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 105.554,
    height: 108.924,
    rx: 32.5647,
    fill: "url(#paint0_radial_6841_62636)",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 105.554,
    height: 108.924,
    rx: 32.5647,
    fill: "url(#paint1_radial_6841_62636)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6841_62636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6181 75.2221C42.2717 75.2221 37.3862 74.176 34.2582 71.7698C33.0656 70.8283 30.7954 72.5858 28.9019 70.0018C26.3598 66.5495 27.2385 63.0239 28.9961 62.0823C31.0884 60.963 32.9087 63.3586 32.9087 63.3586C29.7702 45.8668 36.9259 35.0391 52.6181 35.0391C68.3104 35.0391 75.4347 45.8668 72.3381 63.3586C72.3381 63.3586 74.1794 60.963 76.2507 62.0823C78.0083 63.0239 78.887 66.5495 76.3449 70.0018C74.4514 72.5858 72.1603 70.8283 70.9886 71.7698C67.8606 74.2178 62.975 75.2221 52.6181 75.2221Z",
    fill: "#FFF1D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6181 75.2221C42.2717 75.2221 37.3862 74.176 34.2582 71.7698C33.0656 70.8283 30.7954 72.5858 28.9019 70.0018C26.3598 66.5495 27.2385 63.0239 28.9961 62.0823C31.0884 60.963 32.9087 63.3586 32.9087 63.3586C29.7702 45.8668 36.9259 35.0391 52.6181 35.0391C68.3104 35.0391 75.4347 45.8668 72.3381 63.3586C72.3381 63.3586 74.1794 60.963 76.2507 62.0823C78.0083 63.0239 78.887 66.5495 76.3449 70.0018C74.4514 72.5858 72.1603 70.8283 70.9886 71.7698C67.8606 74.2178 62.975 75.2221 52.6181 75.2221Z",
    fill: "url(#paint2_radial_6841_62636)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0054 62.9272C70.3316 60.8349 69.2645 58.9204 68.9193 54.4324C68.6996 50.1745 67.0362 45.5609 63.8768 44.5461C58.9599 42.9769 57.0559 48.7308 52.6202 48.7308C48.7181 48.7308 46.7722 44.2636 43.0165 44.2636C42.4588 44.2648 41.9046 44.353 41.3741 44.5252C38.2356 45.5713 36.5513 50.1535 36.3316 54.4114C35.9864 58.8994 34.9089 60.7825 33.1932 62.9062L32.8584 63.3247C29.7723 45.8434 36.8861 35.0156 52.5679 35.0156C68.2497 35.0156 75.374 45.8434 72.2879 63.3352L72.0054 62.9272Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7715 26.7812H81.2799V36.5391",
    stroke: "white",
    strokeWidth: 3.00242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7715 83.0703H81.2799V73.3124",
    stroke: "white",
    strokeWidth: 3.00242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7441 26.7812H24.2357V36.5391",
    stroke: "white",
    strokeWidth: 3.00242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7441 83.0703H24.2357V73.3124",
    stroke: "white",
    strokeWidth: 3.00242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4824 55.3047H82.0293",
    stroke: "white",
    strokeWidth: 3.00242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6841_62636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.8545 23.3878) rotate(51.9213) scale(90.328 89.6933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6841_62636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.0946 96.0036) rotate(-93.5572) scale(93.2186 100.707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.861815,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_6841_62636",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6729 43.4105) rotate(44.478) scale(37.4383 38.2809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697917,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6841_62636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.7691,
    height: 62.7696,
    fill: "white",
    transform: "translate(21.2305 23.7734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeheadDiagnosis);
export default __webpack_public_path__ + "static/media/foreheadDiagnosis.19440d2a79c69ef804c0c2b96baa64e4.svg";
export { ForwardRef as ReactComponent };